module.exports = __webpack_public_path__ + "img/flower.c6408acc.png";